// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aY8MT","col":"styles_col__1ovMe","actions":"styles_actions__UeaD4","conflict":"styles_conflict__3qoCi"};